module.exports = __webpack_public_path__ + "static/profile-pic-71fb7aa3e9b3b52659ea6e8b0dc673e6.png";